import moment from 'moment';
import { ConfigConstants } from '../../config/config-constants';

export class WorkScheduleModel {
    public constructor(
        public startOfWork: moment.Moment,
        public endOfWork: moment.Moment,
        public attendanceType: ConfigConstants.AttendanceType,
    ) {}
}
